import { render, staticRenderFns } from "./PosPaperTaxInvoicesSale.vue?vue&type=template&id=74578027&scoped=true&"
import script from "./PosPaperTaxInvoicesSale.vue?vue&type=script&lang=js&"
export * from "./PosPaperTaxInvoicesSale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74578027",
  null
  
)

export default component.exports